module.exports = __webpack_public_path__ + "img/replaceImg.122dbb3f.svg";